import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

type InfoConsultaBNMPProps = {
  url?: string;
};

export const InfoConsultaBNMP: React.FC<InfoConsultaBNMPProps> = ({
  url = "https://portalbnmp.cnj.jus.br/#/pesquisa-peca",
}) => (
  <MUI.Card
    sx={{
      mt: 3,
      p: 3,
      backgroundColor: "#aae2fb",
      border: "2px solid",
      borderColor: "info.main",
      borderRadius: 2,
    }}
  >
    <MUI.Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <MUIcons.Info sx={{ color: "info.main", mr: 1, fontSize: 28 }} />
      <MUI.Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "info.dark" }}
      >
        Como Consultar no Banco Nacional
      </MUI.Typography>
    </MUI.Box>

    <MUI.Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
      Para consultar o mandado no{" "}
      <MUI.Typography
        component="span"
        sx={{ fontWeight: "bold", color: "info.dark" }}
      >
        Banco Nacional de Medidas Penais e Prisões
      </MUI.Typography>
      , copie o Nº do Processo do Mandado desejado, abra a URL abaixo e cole o
      Nº do Processo no campo correspondente, em seguida clique em Pesquisar.
    </MUI.Typography>

    <MUI.Box
      sx={{
        p: 2,
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "info.main",
        borderRadius: 1,
        textAlign: "center",
        mb: 2,
      }}
    >
      <MUI.Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        URL do Portal:
      </MUI.Typography>
      <MUI.Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <MUI.Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontFamily: "monospace",
            color: "primary.main",
            fontWeight: "bold",
            wordBreak: "break-all",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
              color: "primary.dark",
            },
          }}
        >
          {url}
        </MUI.Link>
        <MUI.IconButton
          size="small"
          onClick={() => {
            window.open(url, "_blank", "noopener,noreferrer");
          }}
          sx={{
            color: "primary.main",
            "&:hover": {
              backgroundColor: "primary.light",
            },
          }}
          title="Abrir em nova aba"
        >
          <MUIcons.OpenInNew sx={{ fontSize: 18 }} />
        </MUI.IconButton>
      </MUI.Box>
    </MUI.Box>
  </MUI.Card>
);
